import React from 'react'
import { graphql, Link } from 'gatsby'
import SEO from '../components/seo'
import styled from 'styled-components'
import ProductForm from '../components/ProductForm'
import Img from 'gatsby-image'

const GridLeft = styled.div`
  grid-area: left;
`

const GridRight = styled.div`
  grid-area: right;
`

const Container = styled.div`
  margin: 0 auto;
`
const ImageSection = styled.div`
position: relative;
  svg {
    position: absolute;
    top: 144px;
    z-index: 100;
  }
`
const ImageContain = styled.div`
  margin: 1em 0;
`

const SoldOut = styled.div`
  position:absolute;
  top:0;
  left:10px;
  z-index:1;
   small {
     background:white;
     text-transform:uppercase;
     padding:5px;
     margin-top:10px;
     letter-spacing:3px;
     display:block;
   }
  `


const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2rem 1fr;
  grid-template-rows: 1auto;
  grid-template-areas: 'left . right';
  @media screen and (max-width: 800px) {
    display: block;
  }
`

const ProductTitle = styled.h1`
  margin: 2em 0px 7px;
  font-weight: normal;
`

const ProductDescription = styled.div`
  margin-top: 40px;
  ul {
    margin-left: 3em;
  }
  main {
    outline:none;
  }
`


const ProductPage = ({ data }) => {
  const product = data.shopifyProduct
  const avaiable = product.availableForSale

  return (
    <>
      <SEO title={product.title}  />
      <Container>
        <TwoColumnGrid>
          <GridLeft>
            <p>
              <Link to="/"> Home </Link> / {product.title}{' '}
            </p>
            <ImageSection>
              {!avaiable && <SoldOut><small>Sold Out</small></SoldOut>}
              {product.images.map(image => (
                <ImageContain key={image.id}>
                  <Img
                    fluid={image.localFile.childImageSharp.fluid}
                    key={image.id}
                    alt={product.title}
                  />
                </ImageContain>
              ))}
            </ImageSection>
          </GridLeft>
          <GridRight>
            <ProductTitle>{product.title}</ProductTitle>
            <ProductForm product={product} />
            <ProductDescription
              dangerouslySetInnerHTML={{ __html: product.descriptionHtml }}
            />

          </GridRight>
        </TwoColumnGrid>
      </Container>
    </>
  )
}
export const query = graphql`
  query($handle: String!) {
    shopifyProduct(handle: { eq: $handle }, productType: {eq: "Shirt"}) {
      id
      title
      handle
      productType
      description
      descriptionHtml
      shopifyId
      availableForSale
      options {
        id
        name
        values
      }
      variants {
        id
        title
        price
        image {
          localFile {
            childImageSharp {
              fluid(maxWidth: 910) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        availableForSale
        shopifyId
        selectedOptions {
          name
          value
        }
      }
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      images {
        originalSrc
        id
        localFile {
          childImageSharp {
            fluid(maxWidth: 910) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`

export default ProductPage